/* eslint-disable import/no-cycle */
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const state = {
  comments: [],
  next: null,
  previose: null,
};

// Create a new store
const store = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default store;
